var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLargeLoader = function SvgLargeLoader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2505 4.14169H28.6889V2.50635H30.4675V4.14169H32.906V2.50635H34.6846V4.14169H37.1211V2.50635H38.8997V4.14169H41.3381V2.50635H43.1176V4.14169H45.5551V2.50635H47.3337V4.14169H47.8719V15.6937H39.5444V22.8025H40.8234V25.9648H42.1034V22.1483C42.1036 21.6777 42.4849 21.2964 42.9546 21.2963H46.2121C46.6819 21.2963 47.064 21.6776 47.0641 22.1483V34.2621C47.0639 34.7318 46.6818 35.1132 46.2121 35.1132H46.131V36.0624L45.8237 36.1048L42.5549 36.562V39.3519L42.7368 39.4509L42.9235 39.5518V40.7601H44.5173V45.2967L46.2762 47.0234L46.4279 47.1733V47.4334H46.5834C47.0542 47.4334 47.4363 47.8148 47.4364 48.2846V60.3983C47.4362 60.869 47.0541 61.2504 46.5834 61.2504H46.2158L46.1621 61.2853L45.2422 61.8857L45.1159 61.9686H41.1995V63.0347H45.5674V67.6372C45.5673 68.2589 45.3942 68.9473 45.0932 69.4893C44.8016 70.0145 44.3254 70.5063 43.6803 70.5063H37.6395L37.5622 70.2566L37.1701 69.002H34.8505L34.4583 70.2566L34.3811 70.5063H28.3411C27.6961 70.5063 27.2202 70.0144 26.9282 69.4893C26.627 68.9473 26.4532 68.259 26.4532 67.6372V63.0347H30.8154L30.8191 61.9686H26.9103L26.801 61.9111L25.8462 61.4172L25.5728 61.2749V61.2504H25.5342C25.0636 61.2503 24.6833 60.8689 24.6831 60.3983V48.2846C24.6832 47.8149 25.0636 47.4336 25.5342 47.4334H25.5728V47.3156L25.6812 47.1771L27.3053 45.1223V40.7601H29.0792V39.6366L29.4468 39.4321V36.5459L26.2948 36.1048L25.9876 36.0624V35.1132H25.9056C25.4359 35.1131 25.0547 34.7317 25.0544 34.2621V22.1483C25.0546 21.6777 25.4359 21.2964 25.9056 21.2963H29.163C29.6338 21.2963 30.0159 21.6776 30.0161 22.1483V25.9648H31.1773V22.8025H32.4592V15.6937H24.127V4.14169H24.4719V2.50635H26.2505V4.14169Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.257 2.68457H24.4785V4.34578H26.257V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4738 2.68457H28.6953V4.34578H30.4738V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6906 2.68457H32.9121V4.34578H34.6906V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9054 2.68457H37.127V4.34578H38.9054V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1232 2.68457H41.3438V4.34578H43.1232V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.339 2.68457H45.5605V4.34578H47.339V2.68457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9479 26.7568H30.0684V41.8486H41.9479V26.7568Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.22894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8294 22.9805H31.1836V36.4285H40.8294V22.9805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1948 15.5405H32.8223V42.4598H39.1948V15.5405Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.022 34.44C30.022 34.9099 29.6405 35.2914 29.1696 35.2914H25.912C25.442 35.2914 25.0605 34.9099 25.0605 34.44V22.327C25.0605 21.8561 25.442 21.4746 25.912 21.4746H29.1696C29.6405 21.4746 30.022 21.8561 30.022 22.327V34.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0242 28.396H27.5258L26.3496 28.9841V35.9296L30.0242 36.444V28.396Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.712749
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1094 34.44C42.1094 34.9099 42.4909 35.2914 42.9608 35.2914H46.2184C46.6884 35.2914 47.0699 34.9099 47.0699 34.44V22.327C47.0699 21.8561 46.6884 21.4746 46.2184 21.4746H42.9608C42.4909 21.4746 42.1094 21.8561 42.1094 22.327V34.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6499 60.5763C29.6499 61.0471 29.2684 61.4286 28.7985 61.4286H25.5409C25.07 61.4286 24.6895 61.0471 24.6895 60.5763V48.4632C24.6895 47.9933 25.07 47.6118 25.5409 47.6118H28.7985C29.2684 47.6118 29.6499 47.9933 29.6499 48.4632V60.5763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4805 60.5763C42.4805 61.0471 42.862 61.4286 43.3319 61.4286H46.5895C47.0604 61.4286 47.4419 61.0471 47.4419 60.5763V48.4632C47.4419 47.9933 47.0604 47.6118 46.5895 47.6118H43.3319C42.862 47.6118 42.4805 47.9933 42.4805 48.4632V60.5763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1055 28.396H44.6039L45.7801 28.9841V35.9296L42.1055 36.444V28.396Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.712749
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9705 38.2158H31.9863V39.7494H39.9705V38.2158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.819 41.4443H44.018V45.6886L45.9283 47.563L45.8924 61.039L44.9724 61.6399H27.0409L26.0859 61.1454V47.6694L27.819 45.4763V41.4443Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.01277
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5585 68.9416L34.1255 70.3286C34.1255 70.3286 29.2439 70.3286 28.3481 70.3286C27.4522 70.3286 26.8164 68.9416 26.8164 67.8155C26.8164 66.6894 26.8164 63.5693 26.8164 63.5693H31.2077L34.5585 68.9416Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.712749
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4766 68.9416L37.9096 70.3286C37.9096 70.3286 42.7921 70.3286 43.6879 70.3286C44.5838 70.3286 45.2187 68.9416 45.2187 67.8155C45.2187 66.6894 45.2187 63.5693 45.2187 63.5693H40.8283L37.4766 68.9416Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.712749
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1621 67.6612L32.2055 68.8237H40.0151L40.8495 67.6314V50.165L31.2221 50.7309L31.1621 67.6612Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3182 67.292H40.774V67.5799L39.9802 68.7414H32.2731L31.2832 67.6253L31.3182 67.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0288 61.9092C36.734 61.9092 37.3057 61.3375 37.3057 60.6323C37.3057 59.9271 36.734 59.3555 36.0288 59.3555C35.3236 59.3555 34.752 59.9271 34.752 60.6323C34.752 61.3375 35.3236 61.9092 36.0288 61.9092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0292 58.2298C37.2944 58.2298 38.3201 57.2041 38.3201 55.9389C38.3201 54.6736 37.2944 53.6479 36.0292 53.6479C34.764 53.6479 33.7383 54.6736 33.7383 55.9389C33.7383 57.2041 34.764 58.2298 36.0292 58.2298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6149 39.2035H39.3718L40.0015 38.5469L42.5728 39.9419V49.107L41.9431 51.7052L39.3992 51.7326L38.9071 51.1861L32.9978 51.1308L32.4504 51.6508L30.29 51.7052L29.4414 48.8881V40.0242L31.9583 38.6291L32.6149 39.2035Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5227 4.67578H24.4902V15.5148H47.5227V4.67578Z",
    fill: "#F9BA15",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2886 5.20654H24.7246V8.51101H47.2886V5.20654Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.810206
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_1873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLargeLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "large-loader.1fa4b56a57737a65b3f734f0d69d487b.svg";